<template>
    <div class="text-center">
        <span style="font-size: 36px">
            <i class="far fa-spinner fa-spin text-secondary"></i>
        </span>
        <p class="text-dark mb-0">{{ action }}</p>
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner',

    props: {
        subtitle: {
            type: String,
            required: false,
            default: '',
        },
    },

    computed: {
        action() {
            return this.subtitle === '' ? 'Chargement en cours' : this.subtitle
        },
    },
}
</script>

<style scoped></style>
